export const LOGO_URL = "/logo.webp";

export const EMAIL = "info.clario@gmail.com";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const CITIES = [
  "Milano", "Roma", "Torino", "Bologna", "Firenze", "Napoli",
  "Verona", "Bari", "Genova", "Palermo", "Venezia", "Bergamo",
];

export const SERVICES = [
  {
    id: "civili",
    title: "Pulizie Civili & Residenziali",
    badge: "Abitazioni & Ville",
    description:
      "Pulizia profonda per appartamenti, ville private e residenze di pregio. Trattamento di superfici delicate, parquet, marmi e vetrate.",
    image:
      "https://images.unsplash.com/photo-1562664377-709f2c337eb2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxjbGVhbiUyMG9mZmljZSUyMGNvbW1lcmNpYWwlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTExODY3MjF8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Pulizia pavimentazioni pregiate",
      "Sanificazione bagni e cucine",
      "Trattamento vetri e infissi",
    ],
  },
  {
    id: "uffici",
    title: "Uffici & Spazi Commerciali",
    badge: "Corporate & Coworking",
    description:
      "Programmi ordinari e straordinari per postazioni di lavoro, sale riunioni e aree ristoro, con orari flessibili h24.",
    image:
      "https://images.unsplash.com/photo-1549637642-90187f64f420?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMG9mZmljZSUyMGNvbW1lcmNpYWwlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTExODY3MjF8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Orari non invasivi, pre e post ufficio",
      "Igienizzazione postazioni e telefoni",
      "Fornitura materiale di consumo",
    ],
  },
  {
    id: "condomini",
    title: "Studentati & Parti Comuni",
    badge: "Residenze Studentesche",
    description:
      "Servizi dedicati a studentati, residenze universitarie e parti comuni: scale, ascensori, androni, spazi studio e aree condivise.",
    image:
      "https://images.unsplash.com/photo-1758448511533-e1502259fff6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxhcGFydG1lbnQlMjBidWlsZGluZyUyMGVudHJhbmNlJTIwaGFsbHdheXxlbnwwfHx8fDE3OTExODY3Mjd8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Pulizia aree comuni e spazi studio",
      "Lavaggio scale e vetrate",
      "Referente unico per la gestione",
    ],
  },
  {
    id: "industriali",
    title: "Pulizie Industriali",
    badge: "Capannoni & Logistica",
    description:
      "Interventi specialistici per magazzini, stabilimenti e pavimentazioni in cemento, con macchinari lavasciuga uomo a bordo.",
    image:
      "https://images.unsplash.com/photo-1421940943431-d392fcc1079f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxjbGVhbmVyJTIwd2luZG93JTIwaW5kdXN0cmlhbCUyMHNhbml0aXphdGlvbnxlbnwwfHx8fDE3OTExODY3MjF8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Trattamento resine e pavimenti industriali",
      "Interventi in quota e facciate continue",
      "Operatori certificati D.Lgs 81/08",
    ],
  },
  {
    id: "sanificazioni",
    title: "Sanificazioni Certificate",
    badge: "Protocolli HACCP",
    description:
      "Trattamenti antibatterici e antivirali con nebulizzazione e presidi medico-chirurgici, in conformità HACCP e ASL.",
    image:
      "https://images.unsplash.com/photo-1668600418844-5b3d2e381e10?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxjbGVhbmVyJTIwd2luZG93JTIwaW5kdXN0cmlhbCUyMHNhbml0aXphdGlvbnxlbnwwfHx8fDE3OTExODY3MjF8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Attestato di avvenuta sanificazione",
      "Nebulizzazione a freddo virucida",
      "Conformità protocolli sanitari",
    ],
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => ({ id: s.id, title: s.title }));

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxjbGVhbmVyJTIwd2luZG93JTIwaW5kdXN0cmlhbCUyMHNhbml0aXphdGlvbnxlbnwwfHx8fDE3OTExODY3MjF8MA&ixlib=rb-4.1.0&q=85";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMG9mZmljZSUyMGNvbW1lcmNpYWwlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTExODY3MjF8MA&ixlib=rb-4.1.0&q=85";
